import React, { useState } from 'react';
import '../Login/Modal.css';
import './UserFormModal.css';

const PasswordModal = ({ show, onClose, onSubmit, user }) => {
  const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.password) newErrors.password = '請輸入新密碼';
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = '密碼不一致';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    onSubmit(formData.password);
    setFormData({ password: '', confirmPassword: '' });
    setErrors({});
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>🔑 修改密碼</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <p style={{ marginBottom: 'var(--spacing-md)', color: 'var(--color-text-secondary)' }}>
              正在修改 <strong>{user?.name}</strong> 的密碼
            </p>
            <div className="form-group">
              <label>新密碼 *</label>
              <input
                type="password"
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              />
              {errors.password && <div className="invalid-feedback">{errors.password}</div>}
            </div>
            <div className="form-group">
              <label>確認新密碼 *</label>
              <input
                type="password"
                className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              />
              {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>取消</button>
            <button type="submit" className="btn btn-primary">確認修改</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordModal;
